import { createAction, props } from '@ngrx/store';

export const getMenus = createAction('[Menus] Get All Menus Action');
export const loadMenus = createAction('[Menus] Load All Menus Action', props<{ response: any[] }>());

export const getLoadingState = createAction('[Menus] Get Menu Loading State Action');
export const setLoadingStartState = createAction('[Menus] Set Menu Loading Start State Action');
export const setLoadingEndState = createAction('[Menus] Set Menu Loading End State Action');